import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { resolveStateParams } from '../global/resolves/params.resolve';
import { PagePartnerComponent } from './partner/partner.component';
import { PageJimButtonComponent } from './jimButton/jimButton.component';
import { PageEndeComponent } from './ende/ende.component';
import { PageFaqComponent } from './faq/faq.component';
import { PageImprintComponent } from './imprint/imprint.component';

/* tslint:disable */

export let STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.pages',
    abstract: true
  },
  {
    name: 'main.pages.jimButton',
    url: '/jim-button-foundation',
    views: {
      '$default@': {component: PageJimButtonComponent}
    }
  },
  {
    name: 'main.pages.michaelEnde',
    url: '/michael-ende',
    views: {
      '$default@': {component: PageEndeComponent}
    }
  },
  {
    name: 'main.pages.faq',
    url: '/faq',
    views: {
      '$default@': {component: PageFaqComponent}
    }
  },
  {
    name: 'main.pages.imprint',
    url: '/impressum-agbs',
    views: {
      '$default@': {component: PageImprintComponent}
    }
  },
  {
    name: 'main.pages.planInternational',
    url: '/plan-international',
    views: {
      '$default@': {component: PagePartnerComponent}
    },
    params: {
      partner: {
        logo: {
          url: '/assets/img/partners/logo_plan_international.png',
          width: 103
        },
        image: {
          url: '/assets/img/partners/hero_plan_international.jpg',
          subtitle: 'Plan International Deutschland e.V.'
        },
        content: `<p class="partner-info">Die gemeinnützige Organisation Plan International ist eine weltanschaulich und religiös unabhängige Hilfsorganisation, die sich auf effiziente und transparente Weise weltweit für die Chancen und Rechte von Kindern engagiert.</p>
          <p class="partner-info">Seit über 80 Jahren arbeitet Plan daran, dass Mädchen und Jungen ein Leben frei von Armut, Gewalt und Unrecht führen können. Dabei bindet die Kinderhilfsorganisation Kinder in über 70 Ländern aktiv in die Gestaltung ihrer Zukunft ein. Die nachhaltige Gemeindeentwicklung und Verbesserung der Lebensumstände in den Partnerländern ist oberstes Ziel. Plan International reagiert schnell auf Notlagen und Naturkatastrophen, die das Leben von Kindern bedrohen.</p>
          <p class="partner-info">Die nachhaltigen Entwicklungsziele der Vereinten Nationen bestärken Plan in seinem Engagement für die Gleichberechtigung von Mädchen und Frauen. Mit der Bewegung „Because I am a Girl“ will Plan International sicherstellen, dass sie überall auf der Welt ihr volles Potenzial entfalten.</p>`,
        link: 'https://www.plan.de/-X-ef4ab96',
        person: {
          image: '/assets/img/partners/person_plan_international.png',
          name: 'Maike Röttger',
          description: 'Maike Röttger ist Historikerin, Journalistin und Vorsitzende der Geschäftsführung von Plan International Deutschland. Bildung ist für sie der Schlüssel zu einer besseren Welt.  Sie setzt sich vor allem für Kinder und Jugendliche ein, sodass diese im Leben Zuneigung, Verantwortung und den Wert von Bildung kennen lernen können. Denn dies eröffnet ihnen erst die Chancen und Wahlmöglichkeiten, um ihr Leben selbst in die Hand nehmen zu können. Maike Röttger, die ihre Aufgabe bei Plan International mit großer Bescheidenheit ausführt, ist ein phantastisches Beispiel für jemanden, der sein inneres Kind und seine Lebensfreude nie verloren hat.'
        }
      }
    },
    resolve: [
      resolveStateParams
    ]
  },
  {
    name: 'main.pages.learningLions',
    url: '/learning-lions',
    views: {
      '$default@': {component: PagePartnerComponent}
    },
    params: {
      partner: {
        logo: {
          url: '/assets/img/partners/logo_learning_lions.png',
          width: 174
        },
        image: {
          url: '/assets/img/partners/hero_learning_lions.jpg',
          subtitle: 'Learning Lions'
        },
        content: `<p class="partner-info">
            Die gemeinnützige Organisation Learning Lions von Prinz Ludwig von Bayern hat sich ein besonderes Ziel gesteckt: Sie bekämpft Armut in Afrika durch modernste digitale Technik.
            <br />
            Seit seiner Gründung im Jahr 2015 bietet das Unternehmen jungen Menschen in der verarmten und abgelegenen Region Turkana im Nordwesten Kenias einen Ausweg aus den schwierigen Lebensbedingungen vor Ort.
          </p>
          <p class="partner-info">
            In verschiedenen Etappen werden die Schüler von Learning Lions dazu ermutigt, selbstständig ihr Leben in die Hand zu nehmen und ihr gewonnenes digitales Wissen online anzubieten. Nach einer Ausbildung in den Bereichen Programmieren, Grafikdesign und Medienproduktion können die Schüler als Trainees bei der IT-Outsourcing Agentur der Organisation Digital Lions praktische Erfahrung im internationalen Bereich sammeln, bevor sie dann finanziell unterstützt in die Selbstständigkeit starten können.
          </p>`,
        link: 'http://learninglions.org/',
        person: {
          image: '/assets/img/partners/person_learning_lions.png',
          name: 'Prinz Ludwig von Bayern',
          description: 'Ludwig Heinrich Prinz von Bayern ist ein deutscher IT-Unternehmer, ambitionierter Entwicklungshelfer und Urururenkel von König Ludwig III von Bayern. Vor allem aber ist er ein großherziger Mensch und ein Weltverbesserer, der all seine Möglichkeiten einsetzt, um anderen Menschen zu helfen. Prinz Ludwig von Bayern macht seine Arbeit aus tiefster Überzeugung und mit beispiellosem Engagement und beweist dabei täglich, wie man gute Organisation und Struktur mit viel Herz verbinden kann.'
        }
      }
    },
    resolve: [
      resolveStateParams
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.states.ts